import { render, staticRenderFns } from "./servizi.vue?vue&type=template&id=b7b493c4&"
import script from "./servizi.vue?vue&type=script&lang=js&"
export * from "./servizi.vue?vue&type=script&lang=js&"
import style0 from "./servizi.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports